export default __webpack_public_path__ + "static/media/section4-crypto.0355f421.jpeg";